"use strict";
// I can't define the format of the strings but I can at least declare what type of string Typescript should expect
Object.defineProperty(exports, "__esModule", { value: true });
